import AmplitudeService from "./AmplitudeService"
export default AmplitudeService
